import styled from "styled-components";
import { IconButton } from "@mui/material";

import { StandardLayout } from "@/components/layouts";

export const StyledStandardLayout = styled(StandardLayout)`
    .label {
        font-size: var(--size-14);
    }
`;

export const StyledRemoveIconButton = styled(IconButton)`
    top: 32px;
    right: 0;
    position: absolute;
    z-index: 1;
`;
